/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";
import ServicePath from "@/core/ServicePath";

export default class InterpretationHistoryService extends MainService {
  static listAllPagination(params) {
    return this.postSEC(ServiceConstant.INTERPRETATIONHISTORY_LISTALL_PAGINATION, params);
  }
  static get(params) {
    return this.postSEC(ServicePath.INTERPRETATION_GET_BY_ID, params);
  }
  static getImagebyStudy(params) {
    return this.postSEC(ServicePath.STUDY_FIND_ALL_IMAGES_BY_STUDY, params);
  }
  static update(params) {
    return this.postSEC(ServicePath.INTERPRETATION_UPDATE, params);
  }
  static editFilesColposcopyFromInterpretation(params) {
    return this.postSEC(ServicePath.INTERPRETATION_EDIT_FILES, params);
  }
  static editFormColposcopyFromInterpretation(params) {
    return this.postSEC(ServicePath.INTERPRETATION_EDIT_FORM, params);
  }
  static getAddendums(params) {
    return this.postSEC(ServicePath.INTERPRETATION_GET_ADDENDUMS, params);
  }
  
  static downloadReportHistoryXLSX(params) {
    return this.postPDFSEC(ServiceConstant.INTERPRETATION_REPORT_HISTORY_XLSX, params);
  }

}